
/**
 * External dependencies
 */
import apiFetch from '@wordpress/api-fetch';
import { useEffect, useState } from '@wordpress/element';



export const Block = ({ checkoutExtensionData, extensions }) => {
	var address_html = kgr_php_vars.address_html;
	var address_cart = kgr_php_vars.address_cart;
	var address_info = kgr_php_vars.address_info;
	var address_billinginfo = kgr_php_vars.address_billinginfo;
	jQuery('.forth-form').insertBefore('.wp-block-woocommerce-checkout-billing-address-block');

	console.log(address_billinginfo);
// console.log(address_html);
//   console.log(address_info);
setTimeout(function () {
	jQuery('.first-form').html(address_html);
	jQuery('.second-form').html(address_cart);
	jQuery('.third-form').html(address_info);
	jQuery('.forth-form').html(address_billinginfo);

}, 1000);
	

	return (
		<div className="kl-ga-main-wrap">
		   <div className="first-form"></div>
		   <div className="second-form"></div>
		   <div className="third-form"></div>
		    <div className="forth-form"></div>
		</div>
	);
}